var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"400px","overflow":"auto"}},[_c('vue-editor',_vm._g({attrs:{"value":_vm.value}},_vm.listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }